import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone';
import Typography from '@material-ui/core/Typography';
import styles from './styles'
import MobileCollapse from './MobileCollapse'


class FlightMobile extends Component {

  render() {
    const { classes, flights } = this.props;

    const format = 'h:mma';

    function formatTime(momentTime, timezone) {
      return (moment.tz(momentTime, timezone).format(format))
    }

    

    return (
      <Grid container spacing={3} className={classes.marginTop}>
        <Grid item xs={12} className={classes.header}>
          <Grid container spacing={3}>
              <Grid item xs>
                <Typography>Flight</Typography>
              </Grid>
              <Grid item xs className={classes.mobileText}>
                <Typography>Departure</Typography>
              </Grid>
              <Grid item xs={1} className={classes.mobileText}></Grid>
              <Grid item xs className={classes.mobileText}>
                <Typography>Arrival</Typography>
              </Grid>
              <Grid item xs className={classes.mobileText}>
                <Typography>Status</Typography>
              </Grid>
            </Grid>
        </Grid>
        {flights.map((flight, i) => {
          let departTime = flight.depart.estimated.dateTime ? (
            <div>
              <Typography>
                <b>Scheduled</b>: {formatTime(flight.depart.scheduled.moment, flight.depart.timezone)}
              </Typography>
              <Typography>
                <b>Estimated</b>: {formatTime(flight.depart.estimated.moment, flight.depart.timezone)}
              </Typography>
            </div>
          ) : (<div>
            <Typography>{formatTime(flight.depart.scheduled.moment, flight.depart.timezone)}</Typography>
            <Typography variant="caption">{flight.depart.airport}</Typography>
          </div>
          )
      
          let arriveTime = flight.arrive.estimated.dateTime ? (
            <div>
              <Typography>
                <b>Scheduled</b>: {formatTime(flight.arrive.scheduled.moment, flight.arrive.timezone)}
              </Typography>
              <Typography>
                <b>Estimated</b>: {formatTime(flight.arrive.estimated.moment, flight.arrive.timezone)}
              </Typography>
            </div>
          ) : (<div>
              <Typography>{formatTime(flight.arrive.scheduled.moment, flight.arrive.timezone)}</Typography>
              <Typography variant="caption">{flight.arrive.airport}</Typography>
            </div>
            )
          return (
            <Grid item className={classes[`bg${i%2}`]} xs={12}>
              <Grid container spacing={3}>
                <Grid item xs >
                  <Typography>{flight.flightNumber}</Typography>
                </Grid>
                <Grid item xs className={classes.mobileText}>
                  {departTime}
                </Grid>
                <Grid item xs={1} className={classes.mobileText}>
                  <span class="material-icons">arrow_right</span>
                </Grid>
                <Grid item xs className={classes.mobileText}>
                  {arriveTime}
                </Grid>
                <Grid item xs className={classes.mobileText}>
                  <Typography>{flight.depart.status}</Typography>
                </Grid>
            </Grid>
          </Grid>
          )
        })}
      </Grid>
    );
  }
}

FlightMobile.propTypes = {};

export default withStyles(styles)(FlightMobile);



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/FlightMobile.js